// extracted by mini-css-extract-plugin
export default {"snackbar":"rOEGo","slideUp":"GwQLu","label":"SWzFW","button":"KuVpq","icon":"g3Btd","accept":"rxj2u","warning":"AtMPu","error":"yM3UT"};